
import * as React from "react"
import {
  AlertDialog as ShadcnAlertDialog,
  AlertDialogAction as ShadcnAlertDialogAction,
  AlertDialogCancel as ShadcnAlertDialogCancel,
  AlertDialogContent as ShadcnAlertDialogContent,
  AlertDialogDescription as ShadcnAlertDialogDescription,
  AlertDialogFooter as ShadcnAlertDialogFooter,
  AlertDialogHeader as ShadcnAlertDialogHeader,
  AlertDialogTitle as ShadcnAlertDialogTitle,
  AlertDialogTrigger as ShadcnAlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { cn } from "@/lib/utils"

export interface EnhancedAlertDialogTitleProps extends React.ComponentPropsWithoutRef<typeof ShadcnAlertDialogTitle> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedAlertDialogTitle = React.forwardRef<HTMLHeadingElement, EnhancedAlertDialogTitleProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <ShadcnAlertDialogTitle ref={ref} className={cn(className)} {...props}>
        {children}
      </ShadcnAlertDialogTitle>
    );
  }
);
EnhancedAlertDialogTitle.displayName = "EnhancedAlertDialogTitle";

export interface EnhancedAlertDialogDescriptionProps extends React.ComponentPropsWithoutRef<typeof ShadcnAlertDialogDescription> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedAlertDialogDescription = React.forwardRef<HTMLParagraphElement, EnhancedAlertDialogDescriptionProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <ShadcnAlertDialogDescription ref={ref} className={cn(className)} {...props}>
        {children}
      </ShadcnAlertDialogDescription>
    );
  }
);
EnhancedAlertDialogDescription.displayName = "EnhancedAlertDialogDescription";

export interface EnhancedAlertDialogActionProps extends React.ComponentPropsWithoutRef<typeof ShadcnAlertDialogAction> {
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  form?: string;
}

export const EnhancedAlertDialogAction = React.forwardRef<HTMLButtonElement, EnhancedAlertDialogActionProps>(
  ({ children, className, onClick, type, form, ...props }, ref) => {
    return (
      <ShadcnAlertDialogAction 
        ref={ref} 
        className={cn(className)} 
        onClick={onClick} 
        type={type}
        form={form}
        {...props}
      >
        {children}
      </ShadcnAlertDialogAction>
    );
  }
);
EnhancedAlertDialogAction.displayName = "EnhancedAlertDialogAction";

export interface EnhancedAlertDialogCancelProps extends React.ComponentPropsWithoutRef<typeof ShadcnAlertDialogCancel> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedAlertDialogCancel = React.forwardRef<HTMLButtonElement, EnhancedAlertDialogCancelProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <ShadcnAlertDialogCancel ref={ref} className={cn(className)} {...props}>
        {children}
      </ShadcnAlertDialogCancel>
    );
  }
);
EnhancedAlertDialogCancel.displayName = "EnhancedAlertDialogCancel";

export interface EnhancedAlertDialogContentProps extends React.ComponentPropsWithoutRef<typeof ShadcnAlertDialogContent> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedAlertDialogContent = React.forwardRef<HTMLDivElement, EnhancedAlertDialogContentProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <ShadcnAlertDialogContent ref={ref} className={cn(className)} {...props}>
        {children}
      </ShadcnAlertDialogContent>
    );
  }
);
EnhancedAlertDialogContent.displayName = "EnhancedAlertDialogContent";

// Export the enhanced components as the default names
export const AlertDialogTitle = EnhancedAlertDialogTitle;
export const AlertDialogDescription = EnhancedAlertDialogDescription;
export const AlertDialogAction = EnhancedAlertDialogAction;
export const AlertDialogCancel = EnhancedAlertDialogCancel;
export const AlertDialogContent = EnhancedAlertDialogContent;
